import React, { Component } from "react";
import { Api } from "../../app-controller.js";
import { format } from "date-fns";

class ModalADA extends Component {
  render() {
    return (
      <>
        <div>
          <div id="SolicitudADA">
            <div className="row">
              <div className="col-lg-3">
                <div className="widget100 widget widget-stats bg-gradient-teal m-b-10">
                  <div className="stats-icon stats-icon-lg">
                    <i className="fab fa-lg fa-fw m-r-10 fa-wpforms"></i>
                  </div>
                  <div className="stats-content">
                    <div className="stats-title">Trámite</div>

                    <div className="stats-desc">
                      <h5>{this.props.state.solicitud_ada.accion}</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="widget100 widget widget-stats bg-gradient-yellow m-b-10">
                  <div className="stats-icon stats-icon-lg">
                    <i className="fas fa-lg fa-fw m-r-10 fa-question-circle"></i>
                  </div>
                  <div className="stats-content">
                    <div className="stats-title">Tipo</div>

                    <div className="stats-desc">
                      <h5>{this.props.state.solicitud_ada.tramite}</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="widget100 widget widget-stats bg-gradient-blue m-b-10">
                  <div className="stats-icon stats-icon-lg">
                    <i className="fas fa-lg fa-fw m-r-10 fa-clock"></i>
                  </div>
                  <div className="stats-content">
                    <div className="stats-title">Estatus</div>

                    <div className="stats-desc">
                      <h5>{this.props.state.solicitud_ada.estatus}</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="widget100 widget widget-stats bg-gradient-green m-b-10">
                  <div className="stats-icon stats-icon-lg">
                    <i className="fas fa-lg fa-fw m-r-10 fa-calendar-alt"></i>
                  </div>
                  <div className="stats-content">
                    <div className="stats-title">Fecha</div>

                    <div className="stats-desc">
                      <h5>
                        {this.props.state.solicitud_ada.fecha_solicitud != null
                          ? /*  this.props.state.solicitud.fecha_solicitud
                                    .split("-")
                                    .join("-")
                                    .replaceAll("-", "/") */
                            format(
                              new Date(
                                this.props.state.solicitud_ada.fecha_solicitud
                              ),
                              "dd/MM/yyyy"
                            )
                          : this.props.state.solicitud_ada.fecha_solicitud}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr></hr>
            <div className="row">
              <div
                className={
                  this.props.state.solicitud_ada.estatus_tramite_id === "5"
                    ? "form-group col-md-12"
                    : "hide"
                }
              >
                <button
                  //type=""
                  onClick={this.props.component.handleDesactivarSolicitud}
                  value={this.props.state.solicitud_ada.sol_id}
                  id="desactivar_ada"
                  className="btn btn-info col-md-2 float-right"
                >
                  Desactivar solicitud
                </button>
              </div>
              <fieldset className="col-md-12">
                <legend>Establecimiento</legend>
                <div className="row">
                  <div className="form-group col-md-8">
                    <label>Razón social</label>
                    <div className="form-control">
                      {this.props.state.solicitud_ada.razon_social}
                    </div>
                  </div>
                  <div className="form-group col-md-4">
                    <label>Código IPSA</label>
                    <div className="form-control">
                      {this.props.state.solicitud_ada.codigo}
                    </div>
                  </div>
                  <div className="form-group col-md-12">
                    <label>Dirección</label>
                    <div className="form-control">
                      {this.props.state.solicitud_ada.direccion_establecimiento}
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
            <hr></hr>
            <div
              className={
                this.props.state.solicitud_ada.productos.length > 0
                  ? "row col-md-12"
                  : "row hide"
              }
            >
              <fieldset className="col-md-12">
                <legend>Productos</legend>
                <div className="col-md-12">
                  <table className="table table-striped m-b-0 table-hover">
                    <thead>
                      <tr>
                        <th>No. registro</th>
                        <th>Nombre comercial</th>
                        <th>Pais origen</th>
                        <th>Presentación</th>
                        <th>Cantidad</th>
                        <th>Kilogramos</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.props.state.solicitud_ada.productos.length > 0
                        ? this.props.state.solicitud_ada.productos.map(
                            (pro, index) => (
                              <tr key={index} id={"t" + index}>
                                <td> {"(" + pro.no_registro + ")"}</td>
                                <td>{pro.nombre_comercial}</td>
                                <td>{pro.pais_origen}</td>
                                <td>
                                  {pro.presentacion} ({pro.cantidad_empaque}{" "}
                                  {pro.unidad_medida})
                                </td>
                                <td>{pro.cantidad}</td>
                                <td>{pro.kilogramos}</td>
                              </tr>
                            )
                          )
                        : ""}
                    </tbody>
                  </table>
                </div>
              </fieldset>
            </div>
            <hr></hr>
            <div className="row">
              <fieldset className="col-md-12">
                <legend>Información destino</legend>
                <div className="row">
                  <div className="form-group col-md-12">
                    <label>Destino</label>
                    <div className="form-control">
                      {this.props.state.solicitud_ada.destino}
                    </div>
                  </div>
                  <div className="form-group col-md-6">
                    <label>Nombre del conductor</label>
                    <div className="form-control">
                      {this.props.state.solicitud_ada.nombre_conductor}{" "}
                      {this.props.state.solicitud_ada.apellido_conductor}
                    </div>
                  </div>
                  <div className="form-group col-md-6">
                    <label>Número de cédula</label>
                    <div className="form-control">
                      {this.props.state.solicitud_ada.numero_cedula}
                    </div>
                  </div>
                  <div className="form-group col-md-6">
                    <label>Tipo vehículo</label>
                    <div className="form-control">
                      {this.props.state.solicitud_ada.tipo_vehiculo}
                    </div>
                  </div>
                  <div className="form-group col-md-6">
                    <label>Número de placa</label>
                    <div className="form-control">
                      {this.props.state.solicitud_ada.numero_placa}
                    </div>
                  </div>
                  {/* <div className="form-group col-md-4">
                    <label>Número marchamo</label>
                    <div className="form-control">
                      {this.props.state.solicitud_ada.numero_marchamo}
                    </div>
                  </div> */}
                  <div className="form-group col-md-6">
                    <label>Municipio</label>
                    <div className="form-control">
                      {this.props.state.solicitud_ada.ciudad}
                    </div>
                  </div>
                  <div className="form-group col-md-6">
                    <label>Departamento</label>
                    <div className="form-control">
                      {this.props.state.solicitud_ada.departamento}
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
            <hr></hr>
            <div
              className={
                this.props.state.solicitud_ada.estatus_tramite_id === "5"
                  ? "row"
                  : "hide"
              }
            >
              <fieldset className="col-md-12">
                <legend>Número marchamo</legend>
                <div className="row">
                  <div className="col-md-12">
                    <table className="table table-striped m-b-0 table-hover">
                      <thead>
                        <tr>
                          <th>Número marchamo</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.props.state.solicitud_ada.lista_marchamos.length >
                        0
                          ? this.props.state.solicitud_ada.lista_marchamos.map(
                              (reg, index) => (
                                <tr key={index} id={"t" + index}>
                                  <td>{reg.numero_marchamo}</td>
                                  {/* <td className= {this.props.state.solicitud_ada.estatus_tramite_id === "5" ? "" : "hide"}>
                                    <button
                                      id={index}
                                      onClick={
                                        //this.props.component.removeMarchamo
                                      }
                                      className="btn btn-warning pull-right"
                                    >
                                      <i
                                        id={index}
                                        onClick={
                                          //this.props.component.removeMarchamo
                                        }
                                        className="fas fa-trash"
                                      ></i>
                                    </button>
                                  </td> */}
                                </tr>
                              )
                            )
                          : ""}
                      </tbody>
                    </table>
                  </div>
                </div>
              </fieldset>
            </div>
            <hr></hr>
            <div className="col-md-12">
              <div className="btn-group pull-left col-md-4">
                <button
                  onClick={this.props.component.handleAutorizacionStatus}
                  value="4"
                  id="rechazar_ada"
                  className="btn btn-danger"
                >
                  Rechazar
                </button>
              </div>
              <div className="btn-group pull-right col-md-4">
                {/*    <button id="regresar_mv" className="btn btn-white ">
                            Regresar
                          </button> */}
                <button
                  onClick={this.props.component.handleAutorizacionStatus}
                  value="5"
                  id="aprobar_ada"
                  className="btn btn-success"
                >
                  Aceptar
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default ModalADA;
